<ion-searchbar style="border-bottom:1px solid #DEDEDE" #searchBar (ionChange)="searchFilter$.next($event.target.value)" placeholder="Vpiši vsaj del imena restavracije..." class="search-modal__search" mode="md"></ion-searchbar> 
<ion-list *ngIf="shopList$ | async as sl">

  <ion-item style="border-bottom:1px solid #DEDEDE" *ngFor="let shop of sl?.items; let i = index" [routerLink]="[ '/restavracija/' + shop.providerId + '/' + shop.slug ]" >
    <ion-avatar slot="start">
      <img src="{{ getAvatarUrl( shop.avatar) }}">
    </ion-avatar>
    <ion-label>
      <h2>{{ shop.name }}</h2>
      <p>{{ shop.street }} {{ shop.streetNumber }}, {{ shop.area }}</p>
    </ion-label>
  </ion-item>
 

</ion-list> 

<!--<ion-grid *ngIf="loading"> 
  <ion-row><ion-col class="ion-align-self-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
</ion-grid>-->